/**
 * Prefix a site-relative link ("/products") with the visitor's locale, so a
 * builder link never drops the language. Absolute URLs, anchors ("#faq") and
 * links that already start with "/<locale>" or "/<locale>/" are returned
 * unchanged ("/archive" is not an "ar" link).
 */
export function localizeHref(url: string | null | undefined, locale: string): string {
  const href = url ?? '';
  if (!href.startsWith('/') || href.startsWith('//')) return href;
  if (href === `/${locale}` || href.startsWith(`/${locale}/`)) return href;
  return `/${locale}${href}`;
}
